var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleButtonIconLink',{class:{ 'btn--large btn--icon-next': _vm.isLarge },attrs:{"href":_vm.href,"target":_vm.target,"icon":_vm.icon,"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.linkLabel)+" "),(_vm.isLarge && _vm.hasIntroText)?_c('div',{staticClass:"intro-text"},[_vm._v(_vm._s(_vm.introText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }